export default "__VITE_ASSET__Cxgxekoj__"